import {
  SideNavCategory,
  SideNavCategoryTypeName,
} from '../../../components/side-nav';
import { StandardReport } from '../../../models';

// Formats and adds MyReports and SharedReports to the Searchable Category (hidden)
export const combineWithSearchableCategories = (
  allCategories: SideNavCategory<StandardReport>,
  myReportsCategory: SideNavCategory,
  sharedReportsCategory: SideNavCategory,
): SideNavCategory[] => {
  const searchableCategory = allCategories.items.filter(
    (x) => x.key === SideNavCategoryTypeName.Searchable,
  );

  const combinedReportsCategories = [
    ...myReportsCategory.items,
    ...sharedReportsCategory.items,
  ];

  combinedReportsCategories.forEach((x) => {
    x.formattedSearchText = x.name;
    searchableCategory[0].items.unshift(x);
  });

  return searchableCategory[0].items;
};
